import type { ReploSimpleProject } from "schemas/generated/project";

import * as React from "react";

import { ConnectShopifyCallout } from "@editor/components/editor/page/ConnectShopifyCallout";

import Popover from "@replo/design-system/components/popover/Popover";
import Tooltip from "@replo/design-system/components/tooltip/Tooltip";
import { Link } from "react-router-dom";

type ShopifyButtonProps = {
  isConnected: boolean;
  shopifyUrl?: string;
  project: ReploSimpleProject;
};

const ShopifyButton: React.FC<ShopifyButtonProps> = ({
  isConnected,
  shopifyUrl,
  project,
}) => {
  if (isConnected && shopifyUrl) {
    return (
      <Tooltip content={shopifyUrl} triggerAsChild>
        <Link
          to={`https://${shopifyUrl}`}
          target="_blank"
          className="bg-success-soft flex min-w-fit flex-row items-center gap-1 rounded-sm px-2 py-1"
        >
          <img
            src="/images/shopify-logo.svg"
            alt="Shopify logo"
            className="text-muted h-4 w-4"
            aria-hidden
          />
          <span className="text-muted whitespace-nowrap text-sm">
            Connected
          </span>
        </Link>
      </Tooltip>
    );
  }

  return (
    <Popover
      content={
        <ConnectShopifyCallout
          cookieValue={{
            type: "projectView",
            projectId: project.id,
            workspaceId: project.ownerWorkspaceId,
          }}
        />
      }
      title="Connect Shopify Store"
      description="Replo allows you to access Shopify data dynamically in the editor by connecting your Shopify store."
      side="bottom"
      align="end"
      sideOffset={8}
      triggerAsChild
      shouldPreventDefaultOnInteractOutside={false}
    >
      <button className="bg-surface flex min-w-fit flex-row items-center gap-1 rounded-sm px-2 py-1">
        <img
          src="/images/shopify-logo.svg"
          alt="Shopify logo"
          className="text-muted h-4 w-4"
          aria-hidden
        />
        <span className="text-muted whitespace-nowrap text-sm">
          Connect store
        </span>
      </button>
    </Popover>
  );
};

export default ShopifyButton;
